import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './cleaning-service.views'
import ImageWithSkeleton from '@/components/ImageWithSkeleton'

export const TemplateHeader = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Header bottomBorderColor={'secondary'} backgroundColor={'#ffffff'}>
      <CommonComponents.Wrapper>
        <Layout.Logo>
          {template.logo.src ? (
            <Layout.LogoImage src={template.logo.src} />
          ) : (
            <Layout.LogoText fontFamily={template.logo.fontFamily}>
              {template.logo.text}
            </Layout.LogoText>
          )}
        </Layout.Logo>
        <Layout.Navigation
          hasShoppingCart={template.sections.navigation.hasShoppingCart}
        />
      </CommonComponents.Wrapper>
    </Layout.Header>
  )
}

const CleaningHero = () => {
  const { template } = useTemplateContext()
  
  return (
    <Layout className='select-none pointer-events-none'>
      <TemplateHeader />
      <Layout.Hero backgroundColor={'#ffffff'}>
        <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.TitleContainer>
              <Layout.Title>
                {template.sections.hero.title}
              </Layout.Title>
              <Layout.Subtitle>
                {template.sections.hero.subtitle}
              </Layout.Subtitle>
              <Layout.CTA 
                type="primary"             // Background color for the Cleaning Service button
                variant="contained"        // Contained button style
                textColor="textSecondary"  // Text color as light text (mapped to palette.text.secondary)
              >
                {template.sections.hero.ctaText}
              </Layout.CTA>
            </Layout.TitleContainer>
            <Layout.HeroImageContainer>
            <ImageWithSkeleton src={template.sections.hero.backgroundImage} width={'100%'} key={template.sections.hero.backgroundImage}  />
            </Layout.HeroImageContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default CleaningHero
